import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';

// adSetData EXAMPLE
//   const adSetData = {
//     name: "My New Ad Set", // Replace with the desired ad set name
//     campaign_id: "23842600000000000", // Replace with the desired campaign ID
//     daily_budget: "1000", // Replace with the desired daily budget
//     billing_event: "IMPRESSIONS", // Replace with the desired billing event
//     optimization_goal: "REACH", // Replace with the desired optimization goal
//     status: "PAUSED", // Ad set status (e.g., ACTIVE, PAUSED)
//     targeting: {...}, // Specify targeting details
//   };

// targeting EXAMPLE
// const targeting = {
//   age_max: 65,
//   age_min: 18,
//   geo_locations: {
//     countries: ['US'],
//     location_types: ['home', 'recent'],
//   },
//   locales: [6],
//   brand_safety_content_filter_levels: ['FACEBOOK_STANDARD', 'AN_STANDARD', 'FEED_RELAXED'],
//   targeting_automation: {
//     advantage_audience: 1,
//   },
// };

const CreateAdSet = (props) => {
  const dispatch = useDispatch();
  const { accountId, campaignId } = props;

  const { loadingCreateAdSet } = useSelector((state) => state.general);

  const adSetDataInitialState = { campaign_id: campaignId, status: 'PAUSED', targeting: {}, daily_budget: 0 };

  const [adSetData, setAdSetData] = useState(adSetDataInitialState);

  const handleTargetingChange = (field, value) => {
    setAdSetData({
      ...adSetData,
      targeting: {
        ...adSetData.targeting,
        [field]: value,
      },
    });
  };

  return (
    <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <h5>Create An AdSet</h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 p-4'>
        <div className='col-lg-8 mt-4 pt-lg-0'>
          <label>AdSet Name</label>
          <input
            type='text'
            className='form-control'
            placeholder='AdSet Name...'
            style={{ textAlign: 'center' }}
            value={adSetData.name}
            onChange={(e) => setAdSetData({ ...adSetData, name: e.target.value })}
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Billing Event</label>
          <select
            type='text'
            className='form-control'
            value={adSetData.billing_event}
            onChange={(e) => (e.target.value ? setAdSetData({ ...adSetData, billing_event: e.target.value }) : null)}
          >
            <option value={null}>Select a Billing Event</option>
            <option value='IMPRESSIONS'>IMPRESSIONS</option>
            <option value='LINK_CLICKS'>LINK_CLICKS</option>
          </select>
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Optimization Goal</label>
          <select
            type='text'
            className='form-control'
            value={adSetData.optimization_goal}
            onChange={(e) =>
              e.target.value ? setAdSetData({ ...adSetData, optimization_goal: e.target.value }) : null
            }
          >
            <option value={null}>Select an Optimization Goal</option>
            <option value='REACH'>REACH</option>
            <option value='LINK_CLICKS'>LINK_CLICKS</option>
          </select>
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Daily Budget</label>
          <input
            type='number'
            className='form-control'
            style={{ textAlign: 'center' }}
            value={adSetData.daily_budget}
            onChange={(e) => setAdSetData({ ...adSetData, daily_budget: e.target.value })}
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Status</label>
          <select
            type='text'
            className='form-control'
            value={adSetData.status}
            onChange={(e) => (e.target.value ? setAdSetData({ ...adSetData, status: e.target.value }) : null)}
          >
            <option value={null}>Select a Status</option>
            <option value='ACTIVE'>ACTIVE</option>
            <option value='PAUSED'>PAUSED</option>
          </select>
        </div>
        {/* targeting fields */}
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Age Min</label>
          <input
            type='number'
            className='form-control'
            style={{ textAlign: 'center' }}
            value={adSetData.targeting.age_min || ''}
            onChange={(e) => handleTargetingChange('age_min', e.target.value)}
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Age Max</label>
          <input
            type='number'
            className='form-control'
            style={{ textAlign: 'center' }}
            value={adSetData.targeting.age_max || ''}
            onChange={(e) => handleTargetingChange('age_max', e.target.value)}
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Countries</label>
          <input
            type='text'
            className='form-control'
            placeholder='Comma separated countries...'
            style={{ textAlign: 'center' }}
            value={adSetData.targeting.geo_locations?.countries?.join(', ') || ''}
            onChange={(e) =>
              handleTargetingChange('geo_locations', {
                ...adSetData.targeting.geo_locations,
                countries: e.target.value.split(',').map((country) => country.trim()),
              })
            }
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Location Types</label>
          <input
            type='text'
            className='form-control'
            placeholder='Comma separated location types...'
            style={{ textAlign: 'center' }}
            value={adSetData.targeting.geo_locations?.location_types?.join(', ') || ''}
            onChange={(e) =>
              handleTargetingChange('geo_locations', {
                ...adSetData.targeting.geo_locations,
                location_types: e.target.value.split(',').map((type) => type.trim()),
              })
            }
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Locales</label>
          <input
            type='text'
            className='form-control'
            placeholder='Comma separated locales...'
            style={{ textAlign: 'center' }}
            value={adSetData.targeting.locales?.join(', ') || ''}
            onChange={(e) =>
              handleTargetingChange(
                'locales',
                e.target.value.split(',').map((locale) => parseInt(locale.trim()))
              )
            }
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Brand Safety Content Filter Levels</label>
          <input
            type='text'
            className='form-control'
            placeholder='Comma separated filter levels...'
            style={{ textAlign: 'center' }}
            value={adSetData.targeting.brand_safety_content_filter_levels?.join(', ') || ''}
            onChange={(e) =>
              handleTargetingChange(
                'brand_safety_content_filter_levels',
                e.target.value.split(',').map((level) => level.trim())
              )
            }
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Advantage Audience</label>
          <select
            className='form-control'
            value={adSetData.targeting.targeting_automation?.advantage_audience || 0}
            onChange={(e) =>
              handleTargetingChange('targeting_automation', {
                ...adSetData.targeting.targeting_automation,
                advantage_audience: parseInt(e.target.value),
              })
            }
          >
            <option value={0}>Disabled</option>
            <option value={1}>Enabled</option>
          </select>
        </div>
        {adSetData.name &&
        adSetData.billing_event &&
        adSetData.optimization_goal &&
        adSetData.daily_budget &&
        adSetData.status ? (
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
            <button
              className='btn btn-primary'
              disabled={loadingCreateAdSet}
              onClick={() => {
                dispatch(generalSet({ reduxField: 'loadingCreateAdSet', value: true }));
                dispatch(
                  apiAction({
                    reduxField: 'adSets',
                    route: 'accountDashboard/createFacebookAdSet',
                    accountId,
                    adSetData,
                    addToArray: true,
                    setLoading: 'loadingCreateAdSet',
                  })
                );
                setAdSetData(adSetDataInitialState);
              }}
            >
              Create AdSet
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CreateAdSet;
